import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Fixed } from 'layouts';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import ExternalLinkIcon from '@mui/icons-material/Launch';

const TestReports = () => {
  const theme = useTheme();

  const columns = [
    { field: 'id', headerName: 'Run ID', width: 90 },
    { field: 'branch', headerName: 'Branch', width: 150 },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => (
        <Chip
          label={params.value === 'success' ? 'Passed' : 'Failed'}
          color={params.value === 'success' ? 'success' : 'error'}
          size="small"
        />
      ),
    },
    { field: 'timestamp', headerName: 'Timestamp', width: 200 },
    {
        field: 'reportUrl',
        headerName: 'Report',
        width: 150,
        renderCell: (params) => (
            <Link
                href={params.value}
                target="_blank"
                rel="noopener"
                sx={{ display: 'flex', alignItems: 'center' }}
            >
                View Report <ExternalLinkIcon sx={{ ml: 0.5, fontSize: '1rem' }} />
            </Link>
        ),
    },
  ];

  // Mock data for exploration
  const rows = [
    {
      id: 1,
      branch: 'master',
      status: 'success',
      timestamp: '2026-03-26 10:00:00',
      reportUrl: 'https://startupstrade.gitlab.io/sb-main/-/jobs/123/artifacts/public/index.html',
    },
    {
      id: 2,
      branch: 'feature-tests',
      status: 'failure',
      timestamp: '2026-03-26 11:30:00',
      reportUrl: 'https://startupstrade.gitlab.io/sb-main/-/jobs/124/artifacts/public/index.html',
    },
  ];

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{ xs: '100vh', sm: '100vh', md: 'calc(100vh - 80px)' }}
        sx={{
          overflow: 'auto',
          padding: '20px',
        }}
      >
        <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" fontWeight={700}>
            Playwright Test Reports
          </Typography>
          <Button variant="contained" color="primary" onClick={() => window.open('https://gitlab.com/startupstrade/sb-main/-/pipelines')}>
            View Pipelines
          </Button>
        </Box>
        
        <Typography variant="body1" color="text.secondary" mb={3}>
          Explore the latest end-to-end test results for Selling Bees projects.
        </Typography>

        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: theme.palette.background.level2,
              },
            }}
          />
        </Box>
      </Box>
    </Fixed>
  );
};

export default TestReports;
